import styled from 'styled-components';
import { H1, Text } from '@omilia/typography';
import { colors } from '@omilia/theme';
import { rgba } from 'polished';

import BackgroundImg from 'styles/images/omAccount-background.jpg';

const COLOR_GREY = rgba(colors.COLOR_GREY_1000, 0.16);

export const STitle = styled(H1)`
  color: ${colors.COLOR_GREY_1000};
  font-weight: 300;
  padding-bottom: 34px;
  text-align: center;
`;

export const SAlertBox = styled.div`
  margin-bottom: 25px;
`;

export const SLayout = styled.div`
  align-items: center;
  background-image: url(${BackgroundImg});
  background-repeat: round;
  display: flex;
  flex-direction: column;
  height: 1px;
  justify-content: flex-start;
  min-height: 100vh;
  overflow: auto;
  padding-top: 124px;

  // TODO: Remove me when we ditch Foundation
  button[type='submit'],
  button[type='button'] {
    border-radius: 4px;
  }
`;

export const SForm = styled.div`
  background-color: ${colors.COLOR_WHITE};
  border-radius: 6px;
  border: 1px solid ${colors.COLOR_GREY_300};
  box-shadow: 5px 10px 20px 0 ${COLOR_GREY};
  display: flex;
  flex-direction: column;
  padding: 32px 50px;

  /* each child textfield wrapper fix */
  & > form > div {
    margin: 1rem 0 0;
    min-height: 0;
    padding-bottom: 20px;
  }
`;

export const SFooterText = styled(Text)`
  color: ${colors.COLOR_WHITE};
  margin: 48px 0 32px;
  text-align: center;
`;

export const SExtraInfo = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 21px;

  & > p {
    color: ${colors.COLOR_WHITE};
  }
`;

export const SExtraInfoText = styled(Text)`
  color: ${colors.COLOR_BLUE_600};
  margin-left: 7px;
  text-align: center;
`;

export const SInner = styled.section`
  flex: 1;
  margin-top: 110px;
  max-width: 440px;
  width: 100%;
`;
